import React, { useState } from 'react'
import SideBar from '../../components/SideBar'
import NavBar from '../../components/NavBar'
import Footer from '../../components/Footer'
import { Badge, Tabs } from 'antd'
import PlanComptable from './parameters/PlanComptable'
import SchemaEcritures from './parameters/SchemaEcritures'
import EvenementComptable from './parameters/EvenementComptable'
import Journaux from './parameters/Journaux'
import { BookOutlined, FileTextOutlined, FolderOpenOutlined, SettingOutlined, ThunderboltOutlined } from '@ant-design/icons'

const Parametrage = () => {
    const [activeKey, setActiveKey] = useState('1');

    const onChange = key => {
        console.log(key);
    };

    const items = [
        {
            key: '1',
            label: (
                <span className="flex items-center gap-2 px-2">
                    <BookOutlined style={{ fontSize: '18px' }} />
                    <span className="font-medium">Plan Comptable</span>
                </span>
            ),
            children: <PlanComptable />,
        },
        {
            key: '2',
            label: (
                <span className="flex items-center gap-2 px-2">
                    <FolderOpenOutlined style={{ fontSize: '18px' }} />
                    <span className="font-medium">Journaux</span>
                </span>
            ),
            children: <Journaux />,
        },
        {
            key: '3',
            label: (
                <span className="flex items-center gap-2 px-2">
                    <FileTextOutlined style={{ fontSize: '18px' }} />
                    <span className="font-medium">Schémas d'Écritures</span>
                </span>
            ),
            children: <SchemaEcritures />,
        },
        {
            key: '4',
            label: (
                <span className="flex items-center gap-2 px-2">
                    <ThunderboltOutlined style={{ fontSize: '18px' }} />
                    <span className="font-medium">Événements</span>
                    {/* <Badge count={3} style={{ backgroundColor: '#F39C12' }} /> */}
                </span>
            ),
            children: <EvenementComptable />,
        },
    ];

    return (
        <div className="layout-wrapper layout-content-navbar  ">
            <div className="layout-container">
                <SideBar currentMenu={"COMPTABILITE"} />

                {/* <!-- Layout container --> */}
                <div className="layout-page">
                    <NavBar />
                    {/* <!-- Content wrapper --> */}
                    <div className="content-wrapper">
                        {/* <!-- Content --> */}
                        <div className="container-xxl flex-grow-1 container-p-y">
                            <div style={{ backgroundColor: '#F2F0ED', minHeight: '100vh' }}>
                                <style>{`
        /* Styles personnalisés pour les tabs */
        .custom-tabs .ant-tabs-nav {
          background: linear-gradient(135deg, #FFF3E0 0%, #FFFFFF 100%);
          padding: 24px 32px 0 32px;
          margin: 0;
          border-radius: 16px 16px 0 0;
          box-shadow: 0 2px 8px rgba(243, 156, 18, 0.08);
        }

        .custom-tabs .ant-tabs-nav::before {
          border-bottom: 2px solid #FFF3E0;
        }

        .custom-tabs .ant-tabs-tab {
          padding: 12px 20px;
          margin: 0 8px;
          border-radius: 8px 8px 0 0;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          color: #666;
          font-weight: 500;
        }

        .custom-tabs .ant-tabs-tab:hover {
          background: rgba(243, 156, 18, 0.08);
          color: #A66E00;
        }

        .custom-tabs .ant-tabs-tab-active {
          background: #F39C12;
          color: white !important;
          box-shadow: 0 4px 12px rgba(243, 156, 18, 0.3);
        }

        .custom-tabs .ant-tabs-tab-active .ant-tabs-tab-btn {
          color: white !important;
        }

        .custom-tabs .ant-tabs-ink-bar {
          display: none;
        }

        .custom-tabs .ant-tabs-content-holder {
          background: white;
          border-radius: 0 0 16px 16px;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
        }

        /* Animation pour le contenu */
        .custom-tabs .ant-tabs-tabpane {
          animation: fadeIn 0.4s ease-in-out;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* Styles pour les badges */
        .ant-badge-count {
          box-shadow: 0 2px 6px rgba(243, 156, 18, 0.4);
        }

        /* Effet de survol sur les icônes */
        .custom-tabs .ant-tabs-tab:hover .anticon {
          transform: scale(1.1);
          transition: transform 0.2s ease;
        }

        /* Séparateur subtil entre les tabs */
        .custom-tabs .ant-tabs-tab + .ant-tabs-tab {
          position: relative;
        }

        .custom-tabs .ant-tabs-tab + .ant-tabs-tab::before {
          content: '';
          position: absolute;
          left: -4px;
          top: 50%;
          transform: translateY(-50%);
          height: 20px;
          width: 1px;
          background: rgba(166, 110, 0, 0.15);
          transition: opacity 0.3s;
        }

        .custom-tabs .ant-tabs-tab:hover + .ant-tabs-tab::before,
        .custom-tabs .ant-tabs-tab-active + .ant-tabs-tab::before {
          opacity: 0;
        }
      `}</style>

                                <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '32px' }}>
                                    {/* En-tête avec gradient */}
                                    <div
                                        style={{
                                            background: 'linear-gradient(135deg, #F39C12 0%, #A66E00 100%)',
                                            borderRadius: '16px',
                                            padding: '32px 40px',
                                            marginBottom: '24px',
                                            boxShadow: '0 8px 24px rgba(243, 156, 18, 0.25)',
                                            position: 'relative',
                                            overflow: 'hidden'
                                        }}
                                    >
                                        {/* Effet de fond décoratif */}
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: '-50%',
                                                right: '-10%',
                                                width: '400px',
                                                height: '400px',
                                                background: 'radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%)',
                                                borderRadius: '50%',
                                                pointerEvents: 'none'
                                            }}
                                        />

                                        <div style={{ position: 'relative', zIndex: 1 }}>
                                            <div className="row items-center">
                                                <div
                                                    style={{
                                                        width: '48px',
                                                        height: '38px',
                                                        background: 'rgba(255, 255, 255, 0.2)',
                                                        borderRadius: '12px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        backdropFilter: 'blur(10px)'
                                                    }}
                                                    className='col-2'
                                                >
                                                    <SettingOutlined style={{ fontSize: '24px', color: 'white' }} />
                                                </div>
                                                <div className='col-10' style={{ marginTop: "-20px" }}>
                                                    <h1
                                                        style={{
                                                            fontSize: '28px',
                                                            fontWeight: '700',
                                                            color: 'white',
                                                            margin: 0,
                                                            textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                                                        }}
                                                    >
                                                        Paramètres Comptables
                                                    </h1>
                                                    <p
                                                        style={{
                                                            color: 'rgba(255, 255, 255, 0.9)',
                                                            margin: 0,
                                                            fontSize: '15px',
                                                            fontWeight: '400'
                                                        }}
                                                    >
                                                        Configuration et gestion de votre système comptable
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Tabs avec le nouveau design */}
                                    <Tabs
                                        defaultActiveKey="1"
                                        items={items}
                                        onChange={setActiveKey}
                                        className="custom-tabs"
                                        size="large"
                                    />
                                </div>
                            </div>
                        </div>
                        {/* <!-- / Content --> */}

                        {/* <!-- Footer --> */}
                        <Footer />
                        {/* <!-- / Footer --> */}

                        <div className="content-backdrop fade"></div>
                    </div>
                    {/* <!-- Content wrapper --> */}
                </div>
                {/* <!-- / Layout page --> */}
            </div>

            {/* <!-- Overlay --> */}
            <div className="layout-overlay layout-menu-toggle"></div>

            {/* <!-- Drag Target Area To SlideIn Menu On Small Screens --> */}
            <div className="drag-target"></div>
        </div>
    )
}

export default Parametrage
